export const getDomain = (): string => {
  const domain =
    (window.location?.ancestorOrigins && window.location.ancestorOrigins[0]) ||
    document.referrer;

  return new URL(domain).hostname;
};
